import React from 'react';
import { BookOpenIcon, WrenchScrewdriverIcon, BookmarkIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const gptTools = [
  {
    title: 'Sazzle Survey Analyser GPT (Open Org)',
    description: 'Real example of a GPT that automatically analyzes survey responses and extracts key themes.',
    url: 'https://www.openverse.fyi/resource/sazzle-the-survey-results-analyser?utm_source=news.openorg.fyi&utm_medium=referral&utm_campaign=open-works-032-make-my-company-ai-fluent-now-bye'
  },
  {
    title: 'Vi Competency Path Designer GPT (Open Org)',
    description: 'Example GPT that helps design competency frameworks and career progression paths.',
    url: 'https://www.openverse.fyi/resource/competency-and-career-framework-designer-gpt-tool?utm_source=news.openorg.fyi&utm_medium=referral&utm_campaign=open-works-032-make-my-company-ai-fluent-now-bye'
  }
];

const policies = [
  {
    title: 'AI Data Protection Playbook, by Vanessa Gilardi',
    description: 'Comprehensive guide to protecting data when implementing AI in your organization.',
    url: 'https://www.openverse.fyi/resource/ai-data-protection-playbook?utm_source=news.openorg.fyi&utm_medium=referral&utm_campaign=open-works-032-make-my-company-ai-fluent-now-bye'
  },
  {
    title: 'Generative AI Policy [Template], by Sarah Woods',
    description: 'Ready-to-use policy template for governing AI use in your organization.',
    url: 'https://www.openverse.fyi/resource/generative-ai-policy-template?utm_source=news.openorg.fyi&utm_medium=referral&utm_campaign=open-works-032-make-my-company-ai-fluent-now-bye'
  },
  {
    title: 'AI Policy, by HiBob',
    description: 'Practical AI policy template with clear guidelines and implementation advice.',
    url: 'https://www.openverse.fyi/resource/ai-policy-template?utm_source=news.openorg.fyi&utm_medium=referral&utm_campaign=open-works-032-make-my-company-ai-fluent-now-bye'
  }
];

const promptLibraries = [
  {
    title: 'Shumer Prompt',
    description: 'Collection of high-quality prompts for various AI use cases and workflows.',
    url: 'https://shumerprompt.com/'
  },
  {
    title: 'Four Day Prompt Library',
    description: 'Curated collection of proven prompts for productivity and business applications.',
    url: 'https://prompt.fourday.ai/prompt/eb7ad09b-60bb-4d91-8a75-77b2e7b3fe8e'
  },
  {
    title: 'Napkin AI',
    description: 'AI-powered tool for creating visual diagrams and infographics from text.',
    url: 'https://www.napkin.ai/'
  }
];

const templates = [
  {
    title: 'Hackathons: "What? So What? Now What?" (Miro)',
    description: 'Miro board template to facilitate AI innovation workshops using the Liberating Structures method for critical thinking and idea development.',
    url: 'https://miro.com/miroverse/hackathons-what-so-what-now-what/'
  },
  {
    title: 'Hackathon Starter Kit (Miro)',
    description: 'Miro board template to help teams get organized quickly for AI hackathons and innovation sessions, with frameworks for team roles and project planning.',
    url: 'https://miro.com/miroverse/hackathon-starter-kit/'
  }
];

const LeverageAIUsefulResources = () => (
  <div className="space-y-8">
    <PlaybookSection title="Useful Resources" icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PlaybookCard>
          <ResourceList 
            title="Example GPTs" 
            items={gptTools} 
            icon={WrenchScrewdriverIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Policies & Playbooks" 
            items={policies} 
            icon={BookOpenIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Prompt Libraries & Tools" 
            items={promptLibraries} 
            icon={BookmarkIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Templates" 
            items={templates} 
            icon={DocumentDuplicateIcon}
          />
        </PlaybookCard>
      </div>
    </PlaybookSection>
  </div>
);

export default LeverageAIUsefulResources; 